/**
 * Országnevek magyarul (ISO 3166-1), Magyarország az élen, a többi ábécérendben.
 * A neveket a böngésző adja (Intl.DisplayNames), így nem kell kézzel karbantartani.
 */
const ISO_CODES =
  'AD AE AF AG AI AL AM AO AR AT AU AZ BA BB BD BE BF BG BH BI BJ BN BO BR BS BT BW BY BZ CA CD CF CG CH CI CL CM CN CO CR CU CV CY CZ DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FM FR GA GB GD GE GH GM GN GQ GR GT GW GY HK HN HR HT HU ID IE IL IN IQ IR IS IT JM JO JP KE KG KH KI KM KN KP KR KW KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG MH MK ML MM MN MR MT MU MV MW MX MY MZ NA NE NG NI NL NO NP NR NZ OM PA PE PG PH PK PL PS PT PW PY QA RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SY SZ TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VN VU WS XK YE ZA ZM ZW'.split(' ');

const buildCountryList = (): string[] => {
  let display: Intl.DisplayNames | null = null;
  try {
    display = new Intl.DisplayNames(['hu'], { type: 'region' });
  } catch {
    display = null;
  }
  // Koszovó (XK) nem minden böngészőben ismert
  const fallback: Record<string, string> = { XK: 'Koszovó', HU: 'Magyarország' };
  const names = ISO_CODES.filter((code) => code !== 'HU').map((code) => {
    const name = display?.of(code);
    return name && name !== code ? name : fallback[code] ?? code;
  });
  names.sort((a, b) => a.localeCompare(b, 'hu'));
  return ['Magyarország', ...names];
};

export const COUNTRIES: string[] = buildCountryList();
